import {FieldControl} from '@signature-it/ngx-generic/enums';
import {SelectField} from "./select";

export class UserLookUpField extends SelectField {
    controlType = FieldControl.USER_LOOK_UP;
    usersGroupId: string;
    link: string;
    linkTarget: string;

    constructor(options: {} = {}) {
        super(options);
        this.dynamicOptions = true;
        try {
            const data = JSON.parse(options['additionalInfo']);
            this.usersGroupId = data['usersGroupId'];
            this.link = data['link'] || '';
            this.linkTarget = data['linkTarget'] || '';
        } catch (e) {}
    }
}
